// removed by extract-text-webpack-plugin
module.exports = {"loader":"styles__loader___39G5O","spin":"styles__spin___35VGS","loader_button":"styles__loader_button___1dmmE"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/SpinnerLoad/styles.css
// module id = 3142
// module chunks = 0